function easeIn(t, power) {
  return t ** power;
}
function easeOut(t, power) {
  return 1 - (t * -1 + 1) ** power;
}
function easeInOut(t, power) {
  return t < 0.5 ? t ** power * 2 ** (power - 1) : 1 - (t * -2 + 2) ** power / 2;
}

export { easeIn, easeInOut, easeOut };
//# sourceMappingURL=easings.js.map
